import { render, staticRenderFns } from "./BatteryIcon.vue?vue&type=template&id=1bf82e14&scoped=true"
import script from "./BatteryIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BatteryIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BatteryIcon.vue?vue&type=style&index=0&id=1bf82e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf82e14",
  null
  
)

export default component.exports